import { useEffect } from 'react'

export function useAmazonPayCleanup() {
  useEffect(() => {
    const cleanAmazonPayOverlay = () => {
      // Same logic as before: remove iframes & overlays
      // document.querySelectorAll('iframe').forEach((iframe) => {
      //   if (iframe.src?.includes('amazon')) iframe.remove()
      // })

      const el = document.getElementById('amazonpay-maxo-checkout-freezing-overlay')
      // document.querySelectorAll('[style*="z-index"][style*="position: fixed"]').forEach((el) => {
      //   const rect = el.getBoundingClientRect()
      //   if (rect.width === window.innerWidth && rect.height === window.innerHeight) el.remove()
      // })
      if (el) window.location.reload() // reload the page if the overlay is found
    }

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        cleanAmazonPayOverlay() // run when tab reactivates
      }
    }

    document.addEventListener('visibilitychange', handleVisibility)
    window.addEventListener('pageshow', cleanAmazonPayOverlay) // also works on some webviews
    window.addEventListener('popstate', cleanAmazonPayOverlay)
    return () => {
      window.removeEventListener('popstate', cleanAmazonPayOverlay)
      document.removeEventListener('visibilitychange', handleVisibility)
      window.removeEventListener('pageshow', cleanAmazonPayOverlay)
    }
  }, [])
}
